import React, { useState } from 'react';
import { formatMoney } from '../../../GlobalFunctions';
import Paginate from 'react-paginate';
import { sorticon } from "../../../api/baseUrl";

const Dailyprice = (props) => {
  const [filings, setFilings] = useState(props.filings || []);
  const [currentPage, setCurrentPage] = useState(0);
  const [postsPerPage, setPostsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  });
  const [check, setCheck] = useState(false);
  const indexOfLastPost = (currentPage + 1) * postsPerPage;
  const indexOfFirstPost = currentPage * postsPerPage;

  const sortedFilings = React.useMemo(() => {
    let sortableItems = [...filings];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (sortConfig.key === 'date') {
          const dateA = new Date(a.date).getTime();
          const dateB = new Date(b.date).getTime();
          if (dateA < dateB) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (dateA > dateB) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
        if (sortConfig.key === 'price') {
          if (a.price < b.price) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
          }
          if (a.price > b.price) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
          }
          return 0;
        }
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [filings, sortConfig]);

  const currentPosts = sortedFilings.slice(indexOfFirstPost, indexOfLastPost);

  const handleSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };

  const paginate = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handlePostsPerPage = (e) => {
    setCurrentPage(0);
    setPostsPerPage(Number(e.target.value));
  };

  return (
    <>
      <div className="omc-view-txt inflation-data container container_box">
        <div className="select_drop cement-select-drop">
          <select
            className="selectpicker"
            value={postsPerPage}
            onChange={handlePostsPerPage}
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
        <div className="omc-volume">
          <div className="ask-table-format table-scroll-responsive">
            <table className="table table-responsive" id="cement-table">
              <thead>
                <tr>
                  <th
                    onClick={() => handleSort('date')}
                    className="date-sizing steel-data-row"
                  >
                    <div className="cement-steel-tbl">
                      Date
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th
                    onClick={() => handleSort('name')}
                    className="date-sizing"
                  >
                    <div className="cement-steel-tbl">
                      Brand
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                  <th>
                    <div className="cement-steel-tbl justify-center">Unit</div>
                  </th>
                  <th onClick={() => handleSort('price')}>
                    <div className="cement-steel-tbl justify-align">
                      Price
                      <div
                        className="sorticon"
                        dangerouslySetInnerHTML={{ __html: sorticon }}
                      />
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentPosts.length ? (
                  currentPosts.map((item, index) => (
                    <tr key={index}>
                      <td>{item.date}</td>
                      <td>{item.name}</td>
                      <td className="center-align">{item.unit}</td>
                      <td className="right-align">{formatMoney(item.price)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className="text-center">
                      {check ? 'No Record Found' : 'Loading...'}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {currentPosts.length ? (
            <div className="dropdown-pagination">
              <Paginate
                onPageChange={paginate}
                pageCount={Math.ceil(filings.length / postsPerPage)}
                previousLabel={'Prev'}
                nextLabel={'Next'}
                containerClassName={'pagination'}
                pageLinkClassName={'page-number'}
                previousLinkClassName={'page-number'}
                nextLinkClassName={'page-number'}
                activeLinkClassName={'active'}
                forcePage={currentPage}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};
export default Dailyprice;